import React, {useState, useEffect} from "react";
import { Modal, Checkbox, Select, TextInput, Textarea } from '@mantine/core';
import S from './Modal.module.scss';
import {useNavigate} from "react-router-dom";
import {PatternFormat} from "react-number-format";
import { notifications } from '@mantine/notifications';
import { useForm } from '@mantine/form';

interface ModalProps {
    opened: boolean;
    close: () => void;
    titleModal?: string;
    event?: any;
    question?: boolean;
    textMessage?: string;
    tariffType?: string;
}

interface FormValuesRegistration {
    firstname: string;
    lastname: string;
    middlename: string;
    company: string;
    unit: string;
    position: string;
    phone: string;
    email: string;
    title: string;
    check: boolean;
    event: string;
    tariffType: string;
    flag: boolean;
}

interface FormValuesQuestion {
    firstname: string;
    lastname: string;
    middlename: string;
    company: string;
    unit: string;
    position: string;
    phone: string;
    email: string;
    check: boolean;
    event: string;
    message: string;
}

export const ModalWindow = ({
    opened,
    close,
    titleModal = "Регистрация",
    event,
    question = false,
    textMessage,
    tariffType,
}: ModalProps) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isEventDisabled, setIsEventDisabled] = useState(false);

    useEffect(() => {
        if (opened && event) {
            const eventExists = eventsDataRegistration.find(item => item.value === event);
            if (eventExists) {
                formRegistration.setFieldValue('event', eventExists?.label);
                formQuestion.setFieldValue('event', eventExists?.label);
                setIsEventDisabled(true);
            } else {
                formRegistration.setFieldValue('event', event);
                formQuestion.setFieldValue('event', event);
                setIsEventDisabled(true);
            }
        } else if (opened) {
            setIsEventDisabled(false);
        }
    }, [opened, event]);

    useEffect(() => {
        if (opened && tariffType) {
            formRegistration.setFieldValue('tariffType', tariffType);
        }
    }, [opened, tariffType]);

    const eventsData = [
        { value: 1, label: 'Цифровизация промышленности, Ноябрь 2026' },
        { value: 5, label: 'Транспорт и логистика, Декабрь 2026' },
    ];

    const eventsDataRegistration = [
        { value: 1, label: 'Цифровизация промышленности, Ноябрь 2026' },
        { value: 2, label: 'Цифровизация 4.0: Энергетика-ТоИР-Экология, Октябрь 2025' },
        { value: 3, label: 'ТоИР, Апрель 2026' },
        { value: 4, label: 'Энергетика, Июнь 2026' },
        { value: 5, label: 'Транспорт и логистика, Декабрь 2026' },
    ];

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateFormQuestion = (values: FormValuesQuestion) => {
        const errors: Partial<Record<keyof FormValuesQuestion, string>> = {};

        if (!values.firstname) errors.firstname = 'Обязательное поле';
        if (!values.lastname) errors.lastname = 'Обязательное поле';
        if (!values.company) errors.company = 'Обязательное поле';
        if (!values.unit) errors.unit = 'Обязательное поле';
        if (!values.position) errors.position = 'Обязательное поле';
        if (!values.event) errors.event = 'Обязательное поле';
        if (!values.message) errors.message = 'Обязательное поле';
        if (!values.email) {
            errors.email = 'Обязательное поле';
        } else if (!emailRegex.test(values.email)) {
            errors.email = 'Некорректный email';
        }
        if (!values.phone || values.phone.replace(/\D/g, '').length < 11) {
            errors.phone = 'Заполните номер телефона';
        }
        if (!values.check) errors.check = 'Необходимо согласие на обработку данных';

        return errors;
    };

    const validateFormRegistration = (values: FormValuesRegistration) => {
        const errors: Partial<Record<keyof FormValuesRegistration, string>> = {};

        if (!values.firstname) errors.firstname = 'Обязательное поле';
        if (!values.lastname) errors.lastname = 'Обязательное поле';
        if (!values.company) errors.company = 'Обязательное поле';
        if (!values.unit) errors.unit = 'Обязательное поле';
        if (!values.position) errors.position = 'Обязательное поле';
        if (!values.event) errors.event = 'Обязательное поле';
        if (!values.email) {
            errors.email = 'Обязательное поле';
        } else if (!emailRegex.test(values.email)) {
            errors.email = 'Некорректный email';
        }
        if (!values.phone || values.phone.replace(/\D/g, '').length < 11) {
            errors.phone = 'Заполните номер телефона';
        }
        if (!values.check) errors.check = 'Необходимо согласие на обработку данных';

        return errors;
    };

    const formQuestion = useForm<FormValuesQuestion>({
        initialValues: {
            firstname: '',
            lastname: '',
            middlename: '',
            company: '',
            unit: '',
            position: '',
            email: '',
            phone: '',
            check: false,
            event: '',
            message: textMessage ? textMessage : '',
        },
        validate: (values) => validateFormQuestion(values),
    });

    const formRegistration = useForm<FormValuesRegistration>({
        initialValues: {
            firstname: '',
            lastname: '',
            middlename: '',
            company: '',
            unit: '',
            position: '',
            email: '',
            phone: '',
            title: '',
            check: false,
            event: '',
            tariffType: tariffType ? tariffType : '',
            flag: false,
        },
        validate: (values) => validateFormRegistration(values),
    });

    const sendRequestQuestion = async (values: FormValuesQuestion) => {
        const formData = new FormData();
        formData.append('firstname', values.firstname);
        formData.append('lastname', values.lastname);
        formData.append('middlename', values.middlename);
        formData.append('company', values.company || '');
        formData.append('unit', values.unit || '');
        formData.append('position', values.position || '');
        formData.append('phone', values.phone.replace(/\D/g, ''));
        formData.append('email', values.email);
        formData.append('event', values.event);
        formData.append('message', values.message);

        const response = await fetch('/api/v1/question-legacy', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Ошибка ${response.status}: ${errorText || response.statusText}`);
        }

        return { success: true };
    };

    const sendRequestRegistration = async (values: FormValuesRegistration) => {
        const formData = new FormData();
        formData.append('firstname', values.firstname);
        formData.append('lastname', values.lastname);
        formData.append('middlename', values.middlename);
        formData.append('company', values.company || '');
        formData.append('unit', values.unit || '');
        formData.append('position', values.position || '');
        formData.append('phone', values.phone.replace(/\D/g, ''));
        formData.append('email', values.email);
        formData.append('title', values.title);
        formData.append('event', values.event);
        formData.append('tariffType', values.tariffType || '');
        formData.append('flag', JSON.stringify(values.flag));

        const response = await fetch('/api/v1/registration-legacy', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Ошибка ${response.status}: ${errorText || response.statusText}`);
        }

        return { success: true };
    };

    const handleSubmitQuestion = async (values: FormValuesQuestion) => {
        setIsLoading(true);

        try {
            await sendRequestQuestion(values);
            notifications.show({
                color: 'green',
                autoClose: 5000,
                title: 'Заявка успешно отправлена!',
                message: 'Скоро с вами свяжутся для уточнения деталей',
            });
            formQuestion.reset();
            close();
        } catch (error) {
            notifications.show({
                color: 'red',
                autoClose: 5000,
                title: 'Ошибка при отправке',
                message: 'Пожалуйста, попробуйте позже или свяжитесь с нами по телефону',
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitRegistration = async (values: FormValuesRegistration) => {
        setIsLoading(true);

        try {
            await sendRequestRegistration(values);
            notifications.show({
                color: 'green',
                autoClose: 5000,
                title: 'Заявка успешно отправлена!',
                message: 'Скоро с вами свяжутся для уточнения деталей',
            });
            formRegistration.reset();
            close();
        } catch (error) {
            notifications.show({
                color: 'red',
                autoClose: 5000,
                title: 'Ошибка при отправке',
                message: 'Пожалуйста, попробуйте позже или свяжитесь с нами по телефону',
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        formRegistration.reset();
        formQuestion.reset();
        setIsEventDisabled(false);
        close();
    };

    const handleSelectChange = (value: number | null, form: any) => {
        if (value) {
            const selectedEvent = eventsDataRegistration.find(item => item.value === value);
            if (selectedEvent) {
                form.setFieldValue('event', selectedEvent.label);
            }
        } else {
            form.setFieldValue('event', '');
        }
    };

    return (
        <Modal.Root
            opened={opened}
            onClose={handleClose}
            size="xl"
            centered
            zIndex={305}
        >
            <Modal.Overlay zIndex={304} />
            <Modal.Content>
                <Modal.Header className={S.header}>
                    <Modal.Title className={S.title}>{titleModal}</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body className={S.body}>
                    {question ? (
                        <form onSubmit={formQuestion.onSubmit(handleSubmitQuestion)} className={S.boxForm}>
                            <div className={S.mainForm}>
                                <div className={S.mainFormBlock}>
                                    <TextInput
                                        label="Компания"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('company')}
                                        {...formQuestion.getInputProps('company')}
                                    />
                                    <TextInput
                                        label="Подразделение"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('unit')}
                                        {...formQuestion.getInputProps('unit')}
                                    />
                                    <TextInput
                                        label="Должность"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('position')}
                                        {...formQuestion.getInputProps('position')}
                                    />
                                </div>
                                <div className={S.mainFormBlock}>
                                    <TextInput
                                        label="Фамилия"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('lastname')}
                                        {...formQuestion.getInputProps('lastname')}
                                    />
                                    <TextInput
                                        label="Имя"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('firstname')}
                                        {...formQuestion.getInputProps('firstname')}
                                    />
                                    <TextInput
                                        label="Отчество"
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('middlename')}
                                        {...formQuestion.getInputProps('middlename')}
                                    />
                                </div>
                            </div>
                            <div className={S.mainForm}>
                                <Select
                                    label="Мероприятие"
                                    size="lg"
                                    withAsterisk
                                    className={S.textInput}
                                    key={formQuestion.key('event')}
                                    {...formQuestion.getInputProps('event')}
                                    data={event ? eventsDataRegistration : eventsData}
                                    searchable
                                    styles={{
                                        dropdown: {
                                            zIndex: 400,
                                        },
                                        option: {
                                            fontSize: 14,
                                        },
                                    }}
                                    clearable={!isEventDisabled}
                                    disabled={isEventDisabled}
                                    value={eventsDataRegistration.find(item => item.label === formQuestion.values.event)?.value || null}
                                    onChange={(value) => handleSelectChange(value, formQuestion)}
                                />
                            </div>
                            <div>
                                <div className={S.mainForm}>
                                    <PatternFormat
                                        label="Ваш номер телефона для связи"
                                        withAsterisk
                                        format="+7 ### ### ## ##"
                                        mask="_"
                                        customInput={TextInput}
                                        value={formQuestion.values.phone}
                                        {...formQuestion.getInputProps('phone')}
                                        className={S.textInput}
                                        size="lg"
                                        allowEmptyFormatting
                                    />
                                    <TextInput
                                        label="Укажите, пожалуйста, вашу электронную почту"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('email')}
                                        {...formQuestion.getInputProps('email')}
                                    />
                                </div>
                                <div className={S.questionForm}>
                                    <Textarea
                                        label="Ваш вопрос"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formQuestion.key('message')}
                                        {...formQuestion.getInputProps('message')}
                                    />
                                </div>
                                <div className={S.requiredFieldDiv}>*Обязательное поле</div>
                                <div className={S.buttonDiv}>
                                    <Checkbox
                                        label={
                                            <div className={S.labelCheckbox}>Я даю своё согласие на обработку <span><u
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate('/privacy-policy');
                                                }}>персональных данных</u>
                                </span>
                                            </div>
                                        }
                                        key={formQuestion.key('check')}
                                        {...formQuestion.getInputProps('check', {type: 'checkbox'})}
                                        color="#0C31C8FF"
                                    />
                                    <button className={S.button}
                                            type="submit">{isLoading ? 'Отправка...' : 'ОТПРАВИТЬ'}</button>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <form onSubmit={formRegistration.onSubmit(handleSubmitRegistration)} className={S.boxForm}>
                            {tariffType ? (
                                <TextInput
                                    label="Тариф"
                                    withAsterisk
                                    size="lg"
                                    className={S.textInput}
                                    key={formRegistration.key('tariffType')}
                                    {...formRegistration.getInputProps('tariffType')}
                                    disabled
                                />
                            ) : null}
                            <div className={S.mainForm}>
                                <div className={S.mainFormBlock}>
                                    <TextInput
                                        label="Компания"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('company')}
                                        {...formRegistration.getInputProps('company')}
                                    />
                                    <TextInput
                                        label="Подразделение"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('unit')}
                                        {...formRegistration.getInputProps('unit')}
                                    />
                                    <TextInput
                                        label="Должность"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('position')}
                                        {...formRegistration.getInputProps('position')}
                                    />
                                </div>
                                <div className={S.mainFormBlock}>
                                    <TextInput
                                        label="Фамилия"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('lastname')}
                                        {...formRegistration.getInputProps('lastname')}
                                    />
                                    <TextInput
                                        label="Имя"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('firstname')}
                                        {...formRegistration.getInputProps('firstname')}
                                    />
                                    <TextInput
                                        label="Отчество"
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('middlename')}
                                        {...formRegistration.getInputProps('middlename')}
                                    />
                                </div>
                            </div>
                            <div className={S.mainForm}>
                                <div className={S.additionalFormBlock}>
                                    <TextInput
                                        label="Тема доклада"
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('title')}
                                        {...formRegistration.getInputProps('title')}
                                    />
                                    <div className={S.topicFieldDiv}>
                                        Если у вашей компании есть тема доклада, кейс
                                        или готовое решение, укажите тему.
                                    </div>
                                </div>
                                <Select
                                    label="Мероприятие"
                                    size="lg"
                                    withAsterisk
                                    className={S.textInput}
                                    key={formRegistration.key('event')}
                                    {...formRegistration.getInputProps('event')}
                                    data={event ? eventsDataRegistration : eventsData}
                                    searchable
                                    styles={{
                                        dropdown: {
                                            zIndex: 400,
                                        },
                                        option: {
                                            fontSize: 14,
                                        },
                                    }}
                                    clearable={!isEventDisabled}
                                    disabled={isEventDisabled}
                                    value={eventsData.find(item => item.label === formRegistration.values.event)?.value || null}
                                    onChange={(value) => handleSelectChange(value, formRegistration)}
                                />
                            </div>
                            <Checkbox
                                label={
                                    <div className={S.checkFormLabel}>
                                        Участвую в экскурсии на Череповецкий металлургический комбинат
                                    </div>
                                }
                                key={formRegistration.key('flag')}
                                {...formRegistration.getInputProps('flag', {type: 'checkbox'})}
                                color="#0C31C8FF"
                            />
                            <div>
                                <div className={S.mainForm}>
                                    <PatternFormat
                                        label="Ваш номер телефона для связи"
                                        withAsterisk
                                        format="+7 ### ### ## ##"
                                        mask="_"
                                        customInput={TextInput}
                                        value={formRegistration.values.phone}
                                        {...formRegistration.getInputProps('phone')}
                                        className={S.textInput}
                                        size="lg"
                                        allowEmptyFormatting
                                    />
                                    <TextInput
                                        label="Укажите, пожалуйста, вашу электронную почту"
                                        withAsterisk
                                        size="lg"
                                        className={S.textInput}
                                        key={formRegistration.key('email')}
                                        {...formRegistration.getInputProps('email')}
                                    />
                                </div>
                                <div className={S.requiredFieldDiv}>*Обязательное поле</div>
                                <div className={S.buttonDiv}>
                                    <Checkbox
                                        label={
                                            <div className={S.labelCheckbox}>Я даю своё согласие на обработку <span><u
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate('/privacy-policy');
                                                }}>персональных данных</u>
                                </span>
                                            </div>
                                        }
                                        key={formRegistration.key('check')}
                                        {...formRegistration.getInputProps('check', {type: 'checkbox'})}
                                        color="#0C31C8FF"
                                    />
                                    <button className={S.button}
                                            type="submit">{isLoading ? 'Отправка...' : 'ОТПРАВИТЬ'}</button>
                                </div>
                            </div>
                        </form>
                    )}
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};